import {SERVER} from "../constants";
import {FileUploader, HttpClient, SaveImage} from "../utils/requests";
import {MAP_URL} from "../constants/urls";
import {fixCreateAdviceId} from "../panels/advice/adviceMapper";
import {fixCreateBlogCategoryId} from "../panels/blogCategory/blogCategoryMapper";
import {fixCreateBlogId} from "../panels/blog/blogMapper";
import {fixCreateAdminUsersId} from "../panels/adminUsers/adminUsersMapper";
import {fixConfigId} from "../panels/config/configMapper";
import {fixCreateForumCategoryId} from "../panels/forumCategory/forumCategoryMapper";
import {fixCreateForumId} from "../panels/forum/forumMapper";
import {fixCreateSpecialistCardId} from "../panels/specialistCard/specialistCardMapper";
import {remapper} from "../panels/conversation/conversationMapper";
import {fixCreateConversationAdId} from "../panels/conversationAd/conversationAdMapper";
import {fixCreateAvatarId} from "../panels/avatar/avatarMapper";
import {fixCreateExperimentId} from "../panels/experiment/experimentMapper";
import {fixCreateVariantId} from "../panels/variant/variantMapper";
import {fixCreateUserVariantId} from "../panels/userVariant/userVariantMapper";
import {fixCreateChildWeekId} from "../panels/childWeek/childWeekMapper";
import {fixCreateMarketLoginId} from "../panels/marketLogin/marketLoginMapper";
import {fixCreateWelcomeModalId} from "../panels/welcomeModal/welcomeModalMapper";
import {fixCreateTermsConditionId} from "../panels/termsCondition/termsConditionMapper";
import {fixCreatePlanId} from "../panels/plan/planMapper";
import {fixCreatePlanTypeId} from "../panels/planType/planTypeMapper";
import {fixCreatePromotionId} from "../panels/promotion/promotionMapper";
import {fixCreateDiscountId} from "../panels/discount/diacountMapper";
import {fixCreateBulkDiscountId} from "../panels/bulkDiscount/bulkDiacountMapper";
import {fixCreatePlanFeaturesId} from "../panels/planFeatures/planFeaturesMapper";
import {fixCreateEventBannerId} from "../panels/eventBanner/eventBannerMapper";
import {fixCreateSubscriptionId} from "../panels/subscription/subscriptionMapper";

export async function createOne(resource, params) {
  if (resource === 'conversation') {
    remapper(params.data);
    delete params.data.createProducts;
    delete params.data.createTag;
  }

    if (resource === 'advice' && params.data.pictures) {
        await FileUploader(resource, params, params.data.pictures);
        params.data['bannerImage'] = params.data.url;
        delete params.data.url;
        delete params.data.pictures;
    }

    if (resource === 'forum' && params.data.pictures) {
        await FileUploader(resource, params, params.data.pictures);
        params.data['icon'] = params.data.url;
        delete params.data.url;
        delete params.data.pictures;
    }

    if (resource === 'forumCategory' && params.data.pictures) {
        await FileUploader(resource, params, params.data.pictures);
        params.data['icon'] = params.data.url;
        delete params.data.url;
        delete params.data.pictures;
    }

    if (resource === 'blog' && params.data.pictures) {
        await FileUploader(resource, params, params.data.pictures);
        params.data['icon'] = params.data.url;
        delete params.data.url;
        delete params.data.pictures;
    }

    if (resource === 'planFeatures' && params.data.pictures) {
        await FileUploader(resource, params, params.data.pictures);
        params.data['icon'] = params.data.url;
        delete params.data.url;
        delete params.data.pictures;
    }

    if (resource === 'blogCategory' && params.data.pictures) {
        await FileUploader(resource, params, params.data.pictures);
        params.data['icon'] = params.data.url;
        delete params.data.url;
        delete params.data.pictures;
    }

    if (resource === 'plan' && params.data.pictures) {
        await FileUploader(resource, params, params.data.pictures);
        params.data['icon'] = params.data.url;
        delete params.data.url;
        delete params.data.pictures;
    }

  if (resource === 'conversationAd' && params.data.image) {
    await FileUploader(resource, params, params.data.image);
    params.data['imageUrl'] = params.data.url;
    delete params.data.url;
    delete params.data.image;
  }

  if (resource === 'conversationAd' && params.data.backgroundPicture) {
    await FileUploader(resource, params, params.data.backgroundPicture);
    params.data['backgroundImageUrl'] = params.data.url;
    delete params.data.url;
    delete params.data.backgroundPicture;
  }

  if (resource === 'avatar' && params.data.avatar) {
    await FileUploader(resource, params, params.data.avatar);
    params.data['avatarUrl'] = params.data.url;
    delete params.data.url;
    delete params.data.avatar;
  }

    if (resource === 'eventBanner' && params.data.pictures) {
        await FileUploader(resource, params, params.data.pictures);
        params.data['image'] = params.data.url;
        delete params.data.url;
        delete params.data.pictures;
    }

  if (resource === 'childWeek' && params.data.image) {
    await FileUploader(resource, params, params.data.image);
    params.data['imageUrl'] = params.data.url;
    delete params.data.url;
    delete params.data.image;
  }

  if (resource === 'advice' || resource === "conversationAd" || resource === "discount" || resource === "bulkDiscount") {
    params.data.expirationDate = params.data.expirationDate && new Date(params.data.expirationDate).getTime();
  }

    if (resource === 'promotion') {
        params.data.startDate = params.data.startDate && new Date(params.data.startDate).getTime();
        params.data.endDate = params.data.endDate && new Date(params.data.endDate).getTime();
    }

  if (['advice', 'blog', 'blogCategory', 'forum', 'forumCategory', 'conversationAd', 'childWeek'].includes(resource)) {
    params.data.markets = params.data.adminMarkets?.map(item => item.markets);
  }
    if (['promotion'].includes(resource) || ['discount'].includes(resource) || ['bulkDiscount'].includes(resource)) {
        params.data.plansId = params.data.adminPlansId?.map(item => item.plansId);
        params.data.specialistIds = params.data.adminSpecialistIds?.map(item => item.specialistIds);
        params.data.clinicCategories = params.data.adminClinicCategories?.map(item => item.clinicCategories);
        params.data.specialistCardIds = params.data.adminSpecialistCardIds?.map(item => item.specialistCardIds);
    }
  if (['marketLogin'].includes(resource)) {
        params.data.loginTypes = params.data.adminLoginTypes?.map(item => item.loginTypes);
  }

  return HttpClient(`${SERVER}/${MAP_URL[resource]}`, {
    method: "POST",
    body: JSON.stringify(params.data),
  }).then(({json}) => {
      if (resource === 'advice') {
        return fixCreateAdviceId(params, json);
      } else if (resource === 'blogCategory') {
        return fixCreateBlogCategoryId(params, json);
      } else if (resource === 'blog') {
        return fixCreateBlogId(params, json);
      } else if (resource === 'adminUsers') {
        return fixCreateAdminUsersId(params, json);
      } else if (resource === 'config') {
        return fixConfigId(params, json);
      } else if (resource === 'forumCategory') {
        return fixCreateForumCategoryId(params, json);
      } else if (resource === 'forum') {
        return fixCreateForumId(params, json);
      } else if (resource === 'specialistCard') {
        return fixCreateSpecialistCardId(params, json);
      } else if (resource === 'conversationAd') {
        return fixCreateConversationAdId(params, json);
      } else if (resource === 'avatar') {
        return fixCreateAvatarId(params, json);
      } else if (resource === 'experiment') {
        return fixCreateExperimentId(params, json);
      } else if (resource === 'variant') {
        return fixCreateVariantId(params, json);
      } else if (resource === 'userVariant') {
        return fixCreateUserVariantId(params, json);
      } else if (resource === 'childWeek') {
        return fixCreateChildWeekId(params, json);
      } else if (resource === 'marketLogin') {
          return fixCreateMarketLoginId(params, json);
      } else if (resource === 'welcomeModal') {
          return fixCreateWelcomeModalId(params, json);
      } else if (resource === 'termsCondition') {
          return fixCreateTermsConditionId(params, json);
      } else if (resource === 'plan') {
          return fixCreatePlanId(params, json);
      } else if (resource === 'planType') {
          return fixCreatePlanTypeId(params, json);
      } else if (resource === 'promotion') {
          return fixCreatePromotionId(params, json);
      } else if (resource === 'discount') {
          return fixCreateDiscountId(params, json);
      } else if (resource === 'bulkDiscount') {
          return fixCreateBulkDiscountId(params, json);
      } else if (resource === 'planFeatures') {
          return fixCreatePlanFeaturesId(params, json);
      } else if (resource === 'eventBanner') {
          return fixCreateEventBannerId(params, json);
      } else if (resource === 'subscription') {
          return fixCreateSubscriptionId(params, json);
      }

      return {
        data: {...params.data, id: json.objectId},
      };
    }
  );
}